/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ContractSortBy {
    CONTRACT_NUMBER = 'contractNumber',
    START_DATE = 'startDate',
    END_DATE = 'endDate',
}
